<template>
  <div class="basic-info">
    <h2>{{ $t('accountOverview') }}</h2>
    <div class="content-box" id="account-container">
      <div class="content">
        <p class="text-left little-title">{{ $t('me') }}</p>
        <p class="avatar"><img src="/static/img/dashboard/avatar_2x.png" alt="临时头像" class="img-circle"></p>
        <p class="user-info-name">{{ user.nickname }}</p>
        <p :class="['user-info-type', {'expired': userDataExpired}]">
          <img :src="'/static/img/dashboard/' + roleIcon" alt="You are " v-show="!!roleIcon">{{ role }}
        </p>
        <!-- <p class="user-info-time">
          {{ $t('serviceTime') }}
          <span v-if="showExipreIn"> : {{ currentLang === 'en' ? $t('expireIn') : '' }} {{getExpiredTime()}} {{ currentLang === 'zh' ? $t('expireIn') : '' }}</span>
          <span v-else> : {{ user.value_of_expire_in }} {{$tc(user.unit_of_expire_in,user.value_of_expire_in)}}</span>
        </p>
        <p class="user-info-device">{{ $t('deviceNum') }}<span> : {{ user.max_device_count }} {{$tc('devices',user.max_device_count)}}</span></p> -->
        <div class="main-num">
          <p><span :class='{"expire-in": showExipreIn}'>{{ getExpiredTime() }}</span><br>{{ showExipreIn ? $t('expireIn') : user.value_of_expire_in <= 1 ? $tc(user.unit_of_expire_in, 1) : $tc(user.unit_of_expire_in, 2) }}
            <em class="divider"></em>
          </p>
          <p><span>{{ user.max_device_count }}</span><br>{{ user.max_device_count <= 1 ? $tc('devices', 1) : $tc('devices', 2) }}</p>
        </div>
      </div>
    </div>

    <div class="content-box" id="service-container" v-if="mediaType !== 'phone'">
      <div class="content">
        <p class="little-title">{{ $t('serviceTime') }}</p>
        <div class="main-num">
          <p><span :class='{"expire-in": showExipreIn}'>{{ getExpiredTime() }}</span><br>{{ showExipreIn ? $t('expireIn') : user.value_of_expire_in <= 1 ? $tc(user.unit_of_expire_in, 1) : $tc(user.unit_of_expire_in, 2) }}</p>
          <p><span>{{ user.max_device_count }}</span><br>{{ user.max_device_count <= 1 ? $tc('devices', 1) : $tc('devices', 2) }}</p>
        </div>
        <p class="describe">{{ $t('serviceInstructions') }}</p>
      </div>
    </div>

    <div class="content-box" id="rewards-container" v-if="mediaType !== 'phone'">
      <div class="content">
        <p class="little-title">{{ $t('rewards') }}</p>
        <div class="main-num">
          <p class="first-num"><span class="stress">{{ user.invitation_count }}</span><br>{{
            $tc(user.invitation_count <= 1 ? $tc('friends', 1) : $tc('friends', 2),user.invitation_count )}}</p>
          <p class="second-num"><span class="stress">{{ user.award_days }}</span><br>{{ $tc(user.award_days <= 1 ? $tc('days', 1) : $tc('days', 2), user.award_days ) }}</p>
        </div>
        <div class="describe">{{ $t('rewardsDescribe') }} <router-link to="/reward-rules" class='reward-rules'>{{ $t('rewardRules') }}</router-link></div>
      </div>
    </div>

    <div class="content-box" id="invitation-container" v-if="mediaType !== 'phone'">
      <div class="content">
        <p class="little-title">{{ $t('myInvitationCode') }}</p>
        <p class="invitation-code">{{ $t('invitationCode') }}<span>{{ user.invitation_code }}</span></p>
        <div class="invite-url-component">
          <invite-url :invitation-code="user.invitation_code"></invite-url>
        </div>
      </div>
    </div>

    <p class="clearfix"></p>
  </div>
</template>

<script>
  import locales from './lang'
  import InviteUrl from '../../../components/inviteUrl/Index.vue'
  import {matchEquiment} from '../../../assets/js/matchEquiment.js'
  import { mapState } from 'vuex'
  import { formatTime } from 'src/lib/filters'

  export default {
    name: 'account-component',
    components: {InviteUrl},
    locales,
    computed: {
      ...mapState({
        user: state => state.user,
        currentSymbol: state => state.currentSymbol,
        mediaType: state => state.mediaType,
        bigstCount: state => state.bigstCount
      }),
      userDataExpired() {
        return this.user.value_of_expire_in === 0
      },
      role() {
        if (this.user.role === 'svip') {
          return 'SVIP'
        } else if (this.user.role === 'user') {
          return 'VIP'
        }
      },
      roleIcon() {
        if (this.role === 'SVIP' && this.userDataExpired) {
          return 'svip_gray_2x.png'
        } else if (this.role === 'SVIP') {
          return 'svip_icon_2x.png'
        } else if (this.role === 'VIP' && this.userDataExpired) {
          return 'vip_gray_2x.png'
        } else if (this.role === 'VIP') {
          return 'vip_icon_2x.png'
        }
      },
      currentLang() {
        return this.$store.state.currentLang
      },
      showExipreIn() {
        return this.user.unit_of_expire_in === 'D' && this.user.value_of_expire_in > 10
      }
    },
    mounted() {
      let that = this
      window.onresize = function () {
        that.$store.state.mediaType = matchEquiment()
      }
    },
    methods: {
      getExpiredTime() {
        const user = this.user

        if (this.showExipreIn) {
          return formatTime(new Date(user.expire_at).toString()).split(' ')[0]
        } else {
          return user.value_of_expire_in
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/mixins/gradient";

  * {
    margin: 0;
    padding: 0;
    border: 0;
  }

  .content-box {
    margin: 0 0 0.24rem 0;
    padding-right: .24rem;
    float: left;
    .content {
      min-height: 2.34rem;
      height: 3rem;
      border: 1px solid rgba(224,215,227,1);
      border-radius: 8px;
    }
    .little-title {
      padding: 0 .16rem;
      line-height: .48rem;
      height: .48rem;
      font-size: .16rem;
      border-bottom: 1px solid rgba(224,215,227,1);
      margin-bottom: .2rem;
      color: #111;
      letter-spacing: 0;
    }
    .main-num {
      font-size: 0;
      p {
        padding: .14rem 0 0 0;
        margin-bottom: .46rem;
        display: inline-block;
        text-align: center;
        letter-spacing: 0;
        color: #666;
        font-size: .12rem;
        &:first-child {
          border-right: 1px solid rgba(224,215,227,1);
        }
        @media screen and (min-width: 1260px) and (max-width: 1440px){
          margin-bottom: 0.3rem;
        }
      }
      span {
        height: .86rem;
        line-height: .86rem;
        font-size: 58px;
        color: #111;
        letter-spacing: 0;
      }
    }
    .describe {
      font-size: .14rem;
      line-height: 0.2rem;
      color: #666;
      letter-spacing: 0;
      padding: 0 .2rem;
      text-align: center;
      .reward-rules {
        color: #295FFD;
      }
    }
  }

  #account-container {
    text-align: center;
    color: #333;
    font-size: .16rem;
    .avatar {
      padding-top: .2rem;
    }
    .img-circle {
      height: .66rem;
    }
    .user-info-name {
      font-weight: 700;
      margin-top: .2rem;
      line-height: .2rem;
      width: 100%;
      overflow-x: hidden;
      color: #111;
      text-overflow: ellipsis;
      font-size: 14px;
    }
    .user-info-type {
      font-size: .14rem;
      font-weight: 500;
      color: #DB8E4F;
      letter-spacing: 0;
      line-height: .18rem;
      height: .18rem;
      margin-top: .3rem;
      vertical-align: middle;
      &.expired {
        color: #e0e0e0;
      }
      img {
        vertical-align: middle;
        max-height: .18rem;
        margin: -0.05rem .1rem 0 0;
      }
    }
    .main-num {
      display: none;
    }
  }

  #service-container {
    display: inline-block;
    .main-num {
      p {
        width: 50%;
      }
      .expire-in {
        font-size: 17px;
      }
    }
    .stress:nth-child(2) {
      border-left: 1px solid $gray-light;
      margin: 0 .15rem;
    }
  }

  #rewards-container {
    .main-num p {
      width: 50%;
    }
  }

  #invitation-container {
    padding-right: 0;
    .invitation-code {
      margin-bottom: .1rem;
      text-align: center;
      color: #666;
      font-size: 12px;
      span {
        font-size: .18rem;
        line-height: 1.2rem;
        color: #F15A66;
        letter-spacing: 0;
      }
    }
    .invite-url-component {
      padding: 0 .2rem;
    }
  }

  @mixin pc-style() {
    #account-container {
      width: 22%;
    }
    #service-container, #rewards-container {
      width: 25%;
    }
    #invitation-container {
      width: 28%;
    }
  }

  @mixin pad-style() {
    #account-container, #service-container, #rewards-container, #invitation-container {
      width: 50%;
    }
    #service-container {
      padding-right: 0;
    }
  }

  @mixin phone-style() {
    #account-container {
      width: 100%;
      padding-right: 0;
      .content {
        height: auto;
        border-radius: 5px;
      }
      .user-info-name {
        font-size: .18rem;
        line-height: .24rem;
        color:#111;
        letter-spacing: 0;
        margin-top: .16rem;
        font-weight: 500;
      }
      .avatar {
        padding-top: 0.04rem;
      }
      .main-num {
        display: block;
        margin-top: .24rem;
        p {
          width: 50%;
          padding: 0;
          margin-bottom: .33rem;
          span {
            height: .48rem;
            line-height: .48rem;
            font-size: .48rem;
          }
          &:first-child {
            border-right: none;
            position: relative;
            span.expire-in {
              font-size: .18rem;
            }
            .divider {
              position: absolute;
              right: 0;
              top: .15rem;
              display: block;
              width: 1px;
              height: .4rem;
              opacity: 0.6;
              background: #E0D7E3;
            }
          }
        }
      }
    }

    #service-container, #rewards-container, #invitation-container {
      display: none;
    }
  }

  h2 {
    display: none;
  }
  @media (max-width: 767px) {
    @include phone-style();
    h2 {
      display: block;
      font-size: .24rem;
      line-height: 32px;
      color: #111111;
      font-weight: 600;
      text-align: center;
      margin-bottom: .24rem;
    }
    .content-box {
      .little-title {
        font-size: 0.14rem;
        line-height: .44rem;
        height: .44rem;
      }
    }
    #account-container .user-info-type {
      margin-top: 0.16rem;
    }
  }

  @media (min-width:768px) and (max-width: 1259px) {
    @include pad-style();
  }

  @media (min-width: 1260px) {
    @include pc-style();
  }
</style>



// WEBPACK FOOTER //
// Index.vue?6101336e